import { useEffect } from 'react';
import { useLDClient } from 'launchdarkly-react-client-sdk';

import { UserInfo } from '../../domain/auth';

export const useLDUserContext = (user?: UserInfo, onLDContextReady?: () => void) => {
  const ldClient = useLDClient();

  useEffect(() => {
    if (ldClient && user?.anonymousId && (ldClient.getContext() as LaunchDarklyContextType).user?.key !== user?.anonymousId) {
      const userContext = {
        ...Object.fromEntries(Object.entries(ldClient.getContext()).filter(([key]) => !['key', 'anonymous', 'country'].includes(key))),
        kind: 'multi',
        user: {
          key: user.anonymousId,
          country: user.country,
          locale: user.locale,
        },
      };
      ldClient.identify(userContext).then(onLDContextReady);
    }
  }, [user?.anonymousId, ldClient?.getContext().key]);
};

export type LaunchDarklyContextType = {
  kind: string;
  user?: {
    key: string;
    country?: string;
    locale?: string;
  };
};
